import AuthService from 'services/AuthService'

export default {
    handle(to, from, next) {
        AuthService.loadSession().then(() => {
            if (AuthService.hasUserHaveFindProviderSearch()) {
                const findProviderQuery = JSON.parse(localStorage.getItem('findProviderQuery'))
                localStorage.removeItem('findProviderUserId')
                localStorage.removeItem('findProviderQuery')

                return next({
                    name: 'referrals.new.results',
                    query: findProviderQuery,
                })
            }
            next()
        })
    },
}
